"use client";

import { useEffect } from "react";

export function AnimationsInit() {
    useEffect(() => {
        // Scroll reveal – IntersectionObserver (zava.hu mintájára)
        const reveals = document.querySelectorAll<HTMLElement>("[data-reveal]");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const el = entry.target as HTMLElement;
                        const delay = el.dataset.delay ?? "0";
                        el.style.transitionDelay = `${delay}ms`;
                        el.classList.add("revealed");
                        observer.unobserve(el);
                    }
                });
            },
            { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
        );
        reveals.forEach((el) => observer.observe(el));

        // Nav border on scroll
        const nav = document.querySelector<HTMLElement>("[data-nav]");
        const onScroll = () => {
            if (!nav) return;
            nav.style.borderBottomColor =
                window.scrollY > 60
                    ? "rgba(124,58,237,0.3)"
                    : "rgba(124,58,237,0.1)";
        };
        window.addEventListener("scroll", onScroll, { passive: true });

        return () => {
            observer.disconnect();
            window.removeEventListener("scroll", onScroll);
        };
    }, []);

    return null;
}
